import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { HomePromiseBlock as HomePromiseBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

export const HomePromiseBlock = (
    block: Immutable<{ value: HomePromiseBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.promises,
            "home-oct16-promises",
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div className="main-container">
            <div
                className={concatClassNames([
                    styles.promisesInfo,
                    "home-oct16-promises__info",
                ])}
            >
                <div
                    className={concatClassNames([
                        styles.promisesIconContainer,
                        "home-oct16-promises__icon-container",
                    ])}
                >
                    {block.value.icon ? (
                        <img
                            src={block.value.icon.url}
                            alt="Free Returns Icon"
                            className="home-oct16-promises__icon responsive"
                            loading="lazy"
                            decoding="async"
                        />
                    ) : null}
                </div>
                <ul className="home-oct16-promises__promise-list">
                    {(block.value.promises ?? []).map((promise, index) => (
                        <li
                            key={index}
                            className={concatClassNames([
                                styles.promisesPromise,
                                "home-oct16-promises__promise",
                                "caption-medium",
                            ])}
                        >
                            {promise}
                        </li>
                    ))}
                </ul>
                <h2>{block.value.title}</h2>
                <div
                    className={styles.homeOct16PromisesCopy}
                    dangerouslySetInnerHTML={richHTML(block.value.copy)}
                />
                <a
                    href={block.value.link?.url ?? ""}
                    className={concatClassNames([
                        styles.promisesLink,
                        "home-oct16-promises__link",
                        "link",
                    ])}
                >
                    Learn More
                </a>
            </div>
            <div className={styles.homeOct16PromisesImage}>
                {block.value.image ? (
                    <img
                        src={block.value.image.url}
                        alt="Cocoon by Sealy box with dog"
                        className="responsive"
                        loading="lazy"
                        decoding="async"
                    />
                ) : null}
                <div
                    className={concatClassNames([
                        styles.promisesImageCopy,
                        "home-oct16-promises__image-copy",
                        "caption-light",
                    ])}
                >
                    Your Cocoon&trade; by Sealy is shipped in an easy to move
                    15&rdquo; x 15&rdquo; x 44&rdquo; box. Sorry, cute dog is
                    not included.
                </div>
            </div>
        </div>
    </section>
);
